import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import HttpServices from './api/service/HttpServices'
import {
  setDocumentTitle,
  domTitle
} from '@/utils/domUtil'
import {
  ACCESS_TOKEN, SET_CITY_FLAG
} from '@/store/mutation-types'
import userHelper from '@/utils/helper/userHelper'
import SkipOtherHelper from '@/utils/helper/SkipOtherHelper'
import SilentLoginHelper from '@/utils/helper/silentLoginHelper'

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration
// 路由白名单，配置后可不用登录即可操作页面
const whiteList = ['login', 'register', 'resetPassword', 'registerResult', 'Authorization', 'ImportContacts', 'AuthorizationCode', 'OrderSynchronousRecording', 'ProductSynchronousRecording'] // no redirect whitelist
const autoLoginPath = '/auto/login'//统一登录地址
const userLoginPath = '/users/login'//用户登录地址
function handleRouter(to, from, next) {
  NProgress.start() // start progress bar
  if (to.name) {
    let routeItem = SkipOtherHelper.goPermissionRoute(to.name)
    // console.log("路由跳转",routeItem,to.name)
    if (!routeItem) {
      SkipOtherHelper.routeWarning()
      return
    }
    const item = SkipOtherHelper.getSkipItem(to.name)
    if (item) {
      item.skip()
      return
    }
  }
  let title = store.getters.platformConfig.title
  if (!title) {
    title = domTitle
  }
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${title}`))
  const tokenText = to.query.token //外部跳转过来的
  let updateToken = false
  if (tokenText && tokenText.length > 32) {
    const queryToken = userHelper.decryptToken(tokenText)
    const oldToken = Vue.ls.get(ACCESS_TOKEN)
    if (queryToken && queryToken !== oldToken) {
      updateToken = true
      Vue.ls.set(ACCESS_TOKEN, queryToken, 7 * 24 * 60 * 60 * 1000) //替换token(外部传入)
    }
  }

  if (to.path === '/service/moFangCloud') {
    onCloudServiceHandler(to, next)
  } else if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/users/login') {
      next({
        name: 'home'
      })
    } else {
      if (updateToken || store.getters.roles.length === 0) {
        //切换新用户或者用户数据为为空的时候，都要刷新用户数据
        store.dispatch('GetInfo').then(res => {
          const roles = res.result && res.result.role
          store.dispatch('GetHiddenPermissionList', res.result)
            .then((res) => {
              roles.permissionList = roles.permissionList.filter(item => !res.hiddenPermissionList.some(ele => ele === item))
              // if (!res.own) {
              //   if (res.merchantField.merchantType == 3) {
              //     roles.permissionList.push('ExtractMoney')
              //   } else {
              //     let arr = ['BalanceRecharge', 'ExtractMoney', 'CreditPayment', 'DirectPurchase']
              //     roles.permissionList.push(...arr)
              //   }
              //   roles.permissionList = roles.permissionList.filter(item => item != 'WithdrawList')
              // }
              store.dispatch('GenerateRoutes', { roles }).then(() => {
                // 根据roles权限生成可访问的路由表
                // 动态添加可访问路由表
                // console.log("addRouters",store.getters.addRouters)
                router.addRoutes(store.getters.addRouters)
                const redirect = decodeURIComponent(from.query.redirect || to.path)
                if (to.path === redirect) {
                  // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                  next({
                    ...to,
                    replace: true
                  })
                } else {
                  // 跳转到目的路由
                  next({ path: redirect })
                }
              })
            })
            .catch(reason => errorHandler(next))
        }).catch(() => errorHandler(next))
      } else {
        next()
        // store.dispatch('GetPermissions').then((res) => {
        //   // console.log("GetPermissions",res)
        //   if (to.name) {
        //     let routeItem = SkipOtherHelper.goPermissionRoute(to.name)
        //     // console.log("路由跳转",routeItem,to.name)
        //     if (!routeItem) {
        //       SkipOtherHelper.routeWarning()
        //     } else {
        //       next()
        //     }
        //   } else {
        //     next()
        //   }
        // }).catch(reason => {
        //   next()
        // })
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({
        path: '/users/login',
        query: {
          redirect: to.fullPath
        }
      })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
}

function errorHandler(next) {
  store.dispatch('Logout').then(() => {
    next({
      path: '/users/login'
    })
  })
  setTimeout(() => {
    notification.error({
      message: '错误',
      description: '请求用户信息失败，请重试'
    })
  }, 1500)
}

function beforeHandlerRouter(to, from, next) {
  if ((to.query.token || to.query.code) && to.path === autoLoginPath) {
    //需要静默登录
    if (to.query.token) {
      SilentLoginHelper.silentLogin(next, '/', userLoginPath, to.query.token)
    } else {
      SilentLoginHelper.silentLoginCode(next, '/', userLoginPath, to.query.code)
    }
  } else if (to.path === autoLoginPath) {
    next({ path: userLoginPath, replace: true })//跳转用户的登录
  } else {
    handleRouter(to, from, next)
  }
}

router.beforeEach((to, from, next) => {
  if (store.getters.init) {
    beforeHandlerRouter(to, from, next)
  } else {
    store.dispatch('InitConfig').then((appConfig) => {
      beforeHandlerRouter(to, from, next)
      store.dispatch('initGlobalCity')//城市信息检测
    })

  }
})
router.afterEach(() => {
  NProgress.done() // finish progress bar
})

function onCloudServiceHandler(to, next) {
  if (to.query && to.query.code) {
    next()
  } else {
    HttpServices.getServerApiService().post('feizhu/taobao/taoBaoAuth')
      .then(url => {
        location.href = url
      }).catch(reason => {
      console.error('===========reason=获取淘宝授权失败=========', reason)
    })
  }
}
